import { StyleSheet } from "react-native";
import React from "react";
import { Text, View } from "../Themed";
import Colors from "../../constants/Colors";
import { Feather } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import Pressable from "../Pressable";
import { useSafeAreaInsets } from "react-native-safe-area-context";

interface InputFooterProps {
  handleSubmit: () => void;
  disabled?: boolean;
}

const InputFooter: React.FC<InputFooterProps> = ({
  handleSubmit,
  disabled = false,
}) => {
  const { goBack } = useNavigation();
  const insets = useSafeAreaInsets();
  return (
    <View style={[styles.body, { paddingBottom: insets.bottom + 20 }]}>
      <Pressable
        onPress={() => {
          goBack();
        }}
        style={styles.button}
      >
        <Feather name="x" size={22} color={Colors.nuetral_grey_600} />
        <Text size={18} weight="Bold" style={styles.cancelText}>
          Cancel
        </Text>
      </Pressable>
      <View style={styles.line} />
      <Pressable
        onPress={() => {
          handleSubmit();
        }}
        style={styles.button}
        disabled={disabled}
        hitSlop={30}
      >
        <Feather name="save" size={22} color={Colors.primary_500} />
        <Text size={18} weight="Bold" style={styles.saveText}>
          Save
        </Text>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  body: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 20,
    borderTopWidth: 1,
    borderTopColor: Colors.nuetral_grey_400,
  },
  button: {
    justifyContent: "center",
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  saveText: {
    marginTop: 5,
    color: Colors.primary_500,
    marginLeft: 6,
  },
  cancelText: {
    marginTop: 5,
    color: Colors.nuetral_grey_600,
    marginLeft: 6,
  },
  line: {
    height: 24,
    width: 1,
    backgroundColor: Colors.nuetral_grey_400,
  },
});

export default InputFooter;
